// src/data/solutionData.js
// 이미지 경로는 public/images/ 폴더에 평면 구조로 넣어주세요 (다른 홈페이지 이미지들과 같은 폴더).
// SyncAI 대시보드 캡쳐 등 실제 화면 스크린샷을 그대로 활용하면 신뢰감을 가장 잘 줄 수 있습니다.

export const SOLUTION_DATA = {
  'digital-twin-solution': {
    title: 'Digital Twin for Remote Cultivation',
    tagline: '어디서나 접속해 농장을 운영하는 솔루션',
    heroImage: '/images/solution-digital-twin-hero.png',
    heroOverlay: false,
    description: {
      title: 'Digital Twin for Remote Cultivation',
      paragraphs: [
        'AR 글래스를 쓰면 환경 제어, 생장 분석, 영양 관리, AI 예측, 자동화 시스템 정보가 눈앞에 바로 펼쳐지고, 한국어·영어·중국어·일본어·스페인어 등 다국어로 동일한 내용을 안내받을 수 있습니다.',
        '디지털트윈으로 구현된 동일한 재배 환경을 전 세계 어디서나 같은 화면으로 공유하기 때문에, 언어와 위치에 관계없이 표준화된 방식으로 교육하고 원격으로 농장을 운영할 수 있습니다.'
      ]
    },
    categories: [
      {
        image: '/images/solution-digital-twin-1.jpg',
        title: '실시간 대시보드',
        description: '온도, 습도, CO2, EC, pH 등 센서 데이터를 한 화면에서 확인합니다.'
      },
      {
        image: '/images/solution-digital-twin-2.jpg',
        title: '3D 컨테이너 뷰',
        description: '실제 재배 공간을 3D로 재현해 직관적으로 상태를 파악합니다.'
      },
      {
        image: '/images/solution-digital-twin-3.jpg',
        title: 'AI 분석 연계',
        description: '생장 상태와 병충해 가능성을 AI가 자동으로 분석합니다.'
      }
    ]
  },
  'ai-recipe': {
    title: 'AI based Cultivation Recipe',
    tagline: '데이터 기반으로 최적의 재배 레시피를 추천합니다',
    heroImage: '/images/solution-ai-recipe-hero.png',
    heroOverlay: false,
    description: {
      title: 'AI based Cultivation Recipe',
      paragraphs: [
        '온도, 습도, pH, EC, CO2, 생장 이미지 등 현장의 실시간 데이터를 수집(Data Collection)하면, AI가 이를 분석(AI Analysis)해 생육 예측·건강도 진단·이상 감지·수확량을 예측합니다.',
        '분석 결과는 영양액 배합, 급액 주기, 환경 제어, 조명 레시피로 구성된 최적 재배 레시피(Recipe Generation)로 자동 생성되고, 펌프·팬·LED·CO2 시스템을 통해 즉시 실행(Automatic Control)됩니다.',
        '이 결과는 다시 AI 학습에 반영되어 레시피가 지속적으로 개선됩니다.'
      ]
    },
    categories: [
      {
        image: '/images/solution-ai-recipe-1.jpg',
        title: '생육 예측',
        description: '누적 데이터를 기반으로 수확 시점을 예측합니다.'
      },
      {
        image: '/images/solution-ai-recipe-2.jpg',
        title: '환경 최적화 제안',
        description: '작물별 최적 환경값을 AI가 자동으로 제안합니다.'
      },
      {
        image: '/images/solution-ai-recipe-3.jpg',
        title: '이상 감지 알림',
        description: '생육 이상 신호를 조기에 감지해 알려줍니다.'
      }
    ]
  },
  'image-analysis': {
    title: 'Image Analysis Tool',
    tagline: '이미지 한 장으로 작물의 건강 상태를 진단합니다',
    heroImage: '/images/solution-image-analysis-hero.png',
    heroOverlay: false,
    description: {
      title: 'Image Analysis Tool',
      paragraphs: [
        'AR 글래스로 작물을 바라보면 SyncAI가 이미지를 실시간으로 분석해 건강한 열매와 양분 부족, 병해 위험, 해충 피해를 구분하고, Health Score와 생장 예측치를 그 자리에서 보여줍니다.',
        '분석 결과는 영양 배합, 급액, 환경, 조명 레시피로 즉시 연결되며, 교사와 학생들이 함께 화면을 보고 음성과 레이저 포인터로 의견을 나누는 원격 협업까지 한 번에 이루어집니다.'
      ]
    },
    categories: [
      {
        image: '/images/solution-image-analysis-1.jpg',
        title: '생장 이미지 비교',
        description: '시점별 생장 이미지를 Before/After로 비교합니다.'
      },
      {
        image: '/images/solution-image-analysis-2.jpg',
        title: '엽색, 병충해 진단',
        description: '이미지 분석으로 엽색 변화와 병충해 가능성을 판별합니다.'
      },
      {
        image: '/images/solution-image-analysis-3.jpg',
        title: '리포트 자동 생성',
        description: '분석 결과를 요약한 리포트를 자동으로 생성합니다.'
      }
    ]
  }
};
